import React from 'react';
import { Avatar } from '@material-ui/core';
import { Skeleton, AvatarGroup } from '@material-ui/lab';
import styled from 'styled-components';
import { makeRange } from '../../utils';
import { LARGE_BACKGROUND_IMAGE_SIZE_IN_PX } from '../Image';
const EntityInfo = styled.div `
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;
const Wrapper = styled.div `
    max-width: 700px;
    margin: 0 auto;
    padding: 2rem 0;
`;
const CollaboratorsWrapper = styled.div `
    display: flex;
    margin: 2rem 0;
    align-items: center;

    > span {
        margin-left: 0.5rem;
    }
`;
const FlexContainer = styled.div `
    display: flex;
    justify-content: space-between;
    margin: 0 0.25rem;
`;
const SkillAttributes = styled.div `
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;
const StyledAvatar = styled(Avatar) `
    background-color: transparent !important;
    border: none !important;
`;
const SectionHeaderSkeleton = styled(Skeleton) `
    margin: 1rem 0;
`;
const Divider = styled.hr `
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
`;
const Section = styled.div `
    margin: 12px 12px 2rem 12px;
`;
export const SkillLoader = () => {
    return (React.createElement(Wrapper, null,
        React.createElement(Section, null,
            React.createElement(EntityInfo, null,
                React.createElement(Skeleton, { variant: "rect", width: LARGE_BACKGROUND_IMAGE_SIZE_IN_PX, height: LARGE_BACKGROUND_IMAGE_SIZE_IN_PX })),
            React.createElement(SkillAttributes, null,
                React.createElement(Skeleton, { variant: "text", width: 100 }),
                React.createElement(Skeleton, { variant: "rect", width: 450, height: 50 }),
                React.createElement(Skeleton, { variant: "text", width: 200 }),
                React.createElement(CollaboratorsWrapper, null,
                    React.createElement(AvatarGroup, null, makeRange(1, 4).map((index) => (React.createElement(StyledAvatar, { key: index },
                        React.createElement(Skeleton, { variant: "circle", width: 40, height: 40 }))))),
                    React.createElement(Skeleton, { variant: "rect", width: 200, height: 40 })),
                React.createElement(FlexContainer, null,
                    React.createElement(Skeleton, { variant: "text", width: 100 }),
                    React.createElement(Skeleton, { variant: "text", width: 100 })),
                React.createElement(FlexContainer, null,
                    React.createElement(Skeleton, { variant: "rect", width: 80, height: 45 }),
                    React.createElement("div", null,
                        React.createElement(Skeleton, { variant: "rect", width: 250, height: 45 }))))),
        React.createElement(Divider, null),
        React.createElement(Section, null,
            React.createElement(SectionHeaderSkeleton, { variant: "rect", width: 250, height: 40 }),
            React.createElement(Skeleton, { variant: "rect", height: 400 }),
            React.createElement(SectionHeaderSkeleton, { variant: "rect", width: 250, height: 40 }),
            React.createElement(Skeleton, { variant: "rect", height: 400 }))));
};
//# sourceMappingURL=SkillLoader.js.map